// NEW in v4 (contract §9). A thin reactive read wrapper so consumers — 08's report surfaces, 13's
// impact runs, 18's Orpheus chat — stay off the raw store. v3 had no equivalent: 16 external files
// deep-imported `creditStore` directly, which is exactly what the island barrel now prevents.
import { computed, type ComputedRef } from 'vue'

import type { CreditSlotState } from '../service/creditPresentation'
import { useCreditStore } from '../stores/creditStore'

export interface UseCreditBalance {
  remaining: ComputedRef<number>
  total: ComputedRef<number>
  slotState: ComputedRef<CreditSlotState>
  isTrial: ComputedRef<boolean>
  isLocked: ComputedRef<boolean>
  resetDateLabel: ComputedRef<string>
  /** Fetch once if it has not loaded yet. Cheap to call from every consumer's `onMounted`. */
  ensureLoaded: () => Promise<void>
}

export function useCreditBalance(): UseCreditBalance {
  const store = useCreditStore()

  return {
    remaining: computed(() => store.remaining),
    total: computed(() => store.total),
    slotState: computed(() => store.slotState),
    isTrial: computed(() => store.isTrial),
    isLocked: computed(() => store.isLocked),
    resetDateLabel: computed(() => store.resetDateLabel),
    // Not `refresh()` — `fetchBalance()` already no-ops when loaded, so N consumers mounting at
    // once cost one request, and a consumer can never accidentally force-refetch the whole app's
    // balance just by appearing on screen.
    ensureLoaded: () => store.fetchBalance(),
  }
}
